export default __webpack_public_path__ + "07d231f648d479e4bab14fe31103bcca.svg";